import React from 'react';
import { Row, Col, Container } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck } from '@fortawesome/free-solid-svg-icons';
//CSS
import './style.css';
//
export default function About(props){
    return(
        <section id={props.id} className="about-us gray-light-bg">
            <Container>
            <Row className="align-items-center">
                    <Col md={6}>
                        <div className="about-content-right">
                            <img src={props.image} width="500" alt="sobre nós" className="img-fluid" style={{marginLeft: '-3.5em'}}/>
                        </div>
                    </Col>
                    <Col lg={5}>
                    <h2 className="mt-4">{props.title}</h2>
                        <p className="mb-4">{props.text}</p>
                        <ul className="list-unstyled">
                            {props.list.map((item, i) => 
                                <li className="py-2" key={i}>
                                    <div className="d-flex align-items-center">
                                        <div>
                                            <div className="badge badge-circle badge-red mr-3">
                                                <span><FontAwesomeIcon icon={faCheck}/></span>
                                            </div>
                                        </div>
                                        <div><p className="mb-0">{item}</p></div>
                                    </div>
                                </li>
                            )}
                        </ul>
                    </Col>
                </Row>
            </Container>
        </section>
    );
}